import { Image } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';
import React, { FC } from 'react';
import pdfStyles from '../../pdfDocument/pdfStyles';
import PDFUtils from '../../../utils/pdfUtils';
import { PAPER_SIZE } from '../../../../types/enums';

type Props = {
  qrCodeUrl?: string;
  isSingleLineName: boolean;
  paperSize: PAPER_SIZE;
  qrCodeMarginTop: number;
  isCustomBadge: boolean;
  overrideStyles?: Style;
};

export const BadgeQrCode: FC<Props> = ({
                                         isCustomBadge,
                                         qrCodeUrl,
                                         isSingleLineName,
                                         paperSize,
                                         qrCodeMarginTop,
                                         overrideStyles = {}
}) => {
  const isLetterSize = paperSize === PAPER_SIZE.LETTER;
  const defaultQrCodeStyles = paperSize === PAPER_SIZE.W298_X_100 ? pdfStyles.qrCode298x100 : pdfStyles.qrCode;

  const classes = [
    defaultQrCodeStyles,
    isLetterSize ? pdfStyles.qrCodeLetterSize : {},
    isLetterSize && !isSingleLineName ? pdfStyles.twoLinesQrCodeLetterSize : {},
    { marginTop: isSingleLineName ? qrCodeMarginTop : pdfStyles.qrCode.marginTop },
    isCustomBadge ? { ...pdfStyles.qrCodeFullWidth } : {},
    overrideStyles
  ];

  return <Image cache={false} source={qrCodeUrl && PDFUtils.returnSrc(qrCodeUrl)} style={classes} />;
};
